import type { ReactElement } from 'react'

import './styles.scss'

interface Props {
  percentage: number
}

const ProgressBar = ({ percentage }: Props): ReactElement => {
  return (
    <div className="progress-bar">
      <div className="progress-bar__completion" style={{ width: `${percentage}%` }} />
    </div>
  )
}

export default ProgressBar
